<script setup lang="ts">
import { ref, watch } from 'vue'

import { usePreloaderStore } from '@/stores/preloader.store'

const preloader = usePreloaderStore()

// Отдельная переменная для VOverlay
const showScrim = ref(false)
let timeout: ReturnType<typeof setTimeout> | null = null

watch(
  () => preloader.isLoading,
  (isLoading) => {
    if (isLoading) {
      timeout = setTimeout(() => {
        if (preloader.isLoading) {
          showScrim.value = true
        }
      }, 1000)
    } else {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      showScrim.value = false
    }
  })

</script>

<template>
  <Teleport to="body">
    <VOverlay
      :model-value="showScrim"
      persistent
    />
    <div class="progress-container">
      <VProgressCircular
        v-if="preloader.isLoading"
        :size="50"
        color="primary"
        class="progress"
        indeterminate
      />
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
.progress-container {
  display: contents;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99999;
}

.progress {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
}
</style>
